import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const HelpIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="-1 -1 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path
      d="M6 6C6 4.89543 6.89543 4 8 4C9.10457 4 10 4.89543 10 6C10 6.75709 9.5793 7.41594 8.95897 7.75553C8.47452 8.02072 8 8.44772 8 9V9.25M8 11.25V12.25M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </Svg>
);

HelpIcon.displayName = 'HelpIcon';
